import { initializeApp } from "firebase/app";
import { getAuth, Auth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { firebaseConfig } from "./firebaseConfig";

const app = initializeApp(firebaseConfig);

export const db: ReturnType<typeof getFirestore> = getFirestore();
export const auth: Auth = getAuth(app);
export const storage: ReturnType<typeof getStorage> = getStorage();
export const appStorage: ReturnType<typeof getStorage> = getStorage(app, process.env.REACT_APP_GC_BUCKET_NAME);
